// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// returns the total count of all new modulations using the specified modulationSchemeDescription.
// NOTE - for analog modulations this will compare the verbose description.

const getNewModulationCountByModulationSchemeDescription = modulationSchemeDescription => (dispatch, getState) => {
  const radioModulations = getState().databaseDetails.getIn(['initialValues', 'radioModulations'])

  return (
    radioModulations.reduce((a, d) => (
      castToFloat(d.get('radioModulationId')) === null &&
      d.get('modulationSchemeDescription') === modulationSchemeDescription
        ? ++a
        : a
    ), 0)
  )
}

export default getNewModulationCountByModulationSchemeDescription
